import { __assign, __rest, __spreadArray } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { BasicTableResponsive } from './BasicTableResponsive';
import { BasicTableHead, BasicTableHeadCell, BasicTableBody, BasicTableRow, BasicTableCell, } from './components';
import { defaultCompareValues, defaultCompareValuesAsc, } from './utils/BasicTableUtils';
export var BasicTableManaged = function (_a) {
    var columns = _a.columns, rows = _a.rows, _b = _a.stringCompareOptions, stringCompareOptions = _b === void 0 ? {
        sensitivity: 'base',
    } : _b, _c = _a.compareValuesAsc, compareValuesAsc = _c === void 0 ? defaultCompareValuesAsc : _c, _d = _a.compareValues, compareValues = _d === void 0 ? defaultCompareValues : _d, selectedEntries = _a.selectedEntries, _e = _a.onSelect, onSelect = _e === void 0 ? function () { return undefined; } : _e;
    var _f = React.useState(), sortBy = _f[0], setSortBy = _f[1];
    var _g = React.useState(true), sortAsc = _g[0], setSortAsc = _g[1];
    var isSelectable = typeof selectedEntries !== 'undefined';
    var entries = rows.map(function (i) { return i.data; });
    var selectedEntriesArray = selectedEntries || [];
    var selectEntry = function (e, entry) {
        return onSelect(e, __spreadArray(__spreadArray([], selectedEntriesArray), [entry]));
    };
    var unselectEntry = function (e, entry) {
        return onSelect(e, selectedEntriesArray.filter(function (i) { return i.id !== entry.id; }));
    };
    var isSelected = function (entry) {
        return !!selectedEntriesArray.find(function (i) { return i.id === entry.id; });
    };
    var areAllSelected = selectedEntriesArray.length === entries.length;
    var areNoneSelected = selectedEntriesArray.length === 0;
    var headCheckboxValue = areAllSelected || areNoneSelected ? areAllSelected : undefined;
    var selectAll = function (event) { return onSelect(event, entries); };
    var unselectAll = function (event) { return onSelect(event, []); };
    var headCheckboxOnChange = function (event) {
        if (headCheckboxValue)
            unselectAll(event);
        else
            selectAll(event);
    };
    var compareEntries = function (a, b) {
        return !sortBy
            ? 0
            : compareValues(a[sortBy], b[sortBy], sortAsc, stringCompareOptions, compareValuesAsc);
    };
    var compareRows = function (a, b) { return compareEntries(a.data, b.data); };
    var enrichedRows = rows.map(function (_a) {
        var props = __rest(_a, []);
        return (__assign({ checkbox: isSelectable
                ? {
                    id: props.data.id,
                    onChange: function (e, isChecked) {
                        if (isChecked)
                            selectEntry(e, props.data);
                        else
                            unselectEntry(e, props.data);
                    },
                    isChecked: isSelected(props.data),
                    label: 'Select the row',
                }
                : undefined }, props));
    });
    enrichedRows.sort(compareRows);
    var sortData = function (newSortBy) {
        setSortAsc(sortBy !== newSortBy ? true : !sortAsc);
        setSortBy(newSortBy);
    };
    var sort = function (id, isSortable) {
        if (!isSortable || sortBy !== id)
            return undefined;
        return sortAsc ? 'asc' : 'desc';
    };
    var defaultRenderCell = function (children, key, column) { return (React.createElement(BasicTableCell, { isAlignedRight: column.isAlignedRight, key: key }, children)); };
    return (React.createElement(BasicTableResponsive, null,
        React.createElement(BasicTableHead, { checkbox: isSelectable
                ? {
                    id: 'airport-table-checkbox',
                    isChecked: headCheckboxValue,
                    onChange: headCheckboxOnChange,
                    label: 'Select all rows',
                }
                : undefined }, columns.map(function (_a) {
            var id = _a.id, title = _a.title, isSortable = _a.isSortable, renderCell = _a.renderCell, props = __rest(_a, ["id", "title", "isSortable", "renderCell"]);
            return (React.createElement(BasicTableHeadCell, __assign({ key: JSON.stringify(id), sort: sort(id, isSortable), onClick: function () { return (isSortable ? sortData(id) : null); }, isSortable: isSortable }, props), title));
        })),
        React.createElement(BasicTableBody, null, enrichedRows.map(function (row) {
            var data = row.data, props = __rest(row, ["data"]);
            return (React.createElement(BasicTableRow, __assign({ key: data.id }, props), columns.map(function (column) {
                var key = row.data.id + "#" + column.id;
                return column.renderCell
                    ? column.renderCell(row.data[column.id], key, column, row)
                    : defaultRenderCell(row.data[column.id], key, column);
            })));
        }))));
};
BasicTableManaged.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        renderCell: PropTypes.func,
    })).isRequired,
    rows: PropTypes.arrayOf(PropTypes.shape({
        data: PropTypes.shape({
            // eslint-disable-next-line react/forbid-prop-types
            id: PropTypes.any.isRequired,
        }),
    })).isRequired,
    stringCompareOptions: PropTypes.shape({
        usage: PropTypes.string,
        localeMatcher: PropTypes.string,
        numeric: PropTypes.bool,
        caseFirst: PropTypes.string,
        sensitivity: PropTypes.string,
        ignorePunctuation: PropTypes.bool,
    }),
    compareValuesAsc: PropTypes.func,
    compareValues: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    selectedEntries: PropTypes.array,
    onSelect: PropTypes.func,
    zebra: PropTypes.oneOf(['rows', 'none']),
    data: PropTypes.shape({
        // eslint-disable-next-line react/forbid-prop-types
        id: PropTypes.any.isRequired,
    }),
};
//# sourceMappingURL=BasicTableManaged.js.map